import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-developers-overlay-section',
  templateUrl: './developers-overlay-section.component.html',
  styleUrls: ['./developers-overlay-section.component.scss']
})
export class DevelopersOverlaySectionComponent implements OnInit {

  @Output() becomeMerchantClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

}
